import { inject, Injectable } from '@angular/core';
import { API_PUBLIC_PREFIX } from '@core/config-angular';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { type GetTimeslotsResponse } from '@innogy/feh/models';

@Injectable()
export class GetTimeslotsService {
  private readonly apiUrl = inject(API_PUBLIC_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);

  public readonly apiVersion = '1';
  public readonly endpoint = `${this.apiUrl || ''}/feh/timeslots/v${
    this.apiVersion
  }`;

  public call$(): Observable<GetTimeslotsResponse> {
    const headers = { Accept: 'application/json' };
    return this.httpClient.get<GetTimeslotsResponse>(this.endpoint, {
      headers,
    });
  }
}
